<template>
  <v-navigation-drawer
    :value="isOpenImageEditor"
    :permanent="isOpenImageEditor"
    :width="'100vw'"
    max-width="100vw"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="z-index: 16;transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        ref="base-toolbar"
        :dark="false"
        @close="close"
        @save="submit"
        :title="$t('images.edit.title')"
        :button-save-disabled="!payload.content"
        :loader-save="submitLoading"
        type-title="icon"
        color="white"
        button-save
      />
      <v-card-text v-if="payload.id" style="position: relative; overflow-y: auto;height: calc(100vh - 64px)">
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-card max-height="100%">
                <v-card-title class="subtitle-1">
                  {{ $t('images.edit.original') }}
                </v-card-title>
                <v-divider />
                <VueCropper
                  ref="cropper"
                  :src="payload.url || ''"
                  :containerStyle="{
                    height: '400px',
                    maxHeight: '400px'
                  }"
                  :zoomable="false"
                  :zoomOnTouch="false"
                  :zoomOnWheel="false"
                  @cropend="crop"
                  style="height: 400px; max-height: 400px"
                />
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card max-height="100%">
                <v-card-title class="subtitle-1">
                  {{ $t('images.edit.preview') }}
                  <v-spacer />
                  <v-progress-circular
                    v-show="resultLoading"
                    indeterminate
                    color="grey"
                    size="24"
                  />
                </v-card-title>
                <v-divider />
                <v-img
                  :src="payload.content || ''"
                  :lazy-src="payload.content || ''"
                  max-width="100%"
                  height="400"
                  max-height="400"
                  contain
                  class="chess-bg"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import jimp from 'jimp/browser/lib/jimp'
import BaseToolbar from '@/components/BaseToolbar'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'ImageEditor',
  components: {
    BaseToolbar,
    VueCropper
  },
  data () {
    return {
      submitLoading: false,
      resultLoading: false,
      payload: {
        id: null,
        url: null,
        name: null,
        ext: null,
        size: null,
        type: null,
        content: null
      }
    }
  },
  computed: {
    ...mapGetters({
      windowSize: 'windowSize',
      image: 'images/image',
      isOpenImageEditor: 'images/isOpenImageEditor'
    })
  },
  watch: {
    image (newVal, oldVal) {
      if (newVal) {
        this.setEditData()
      }
    }
  },
  methods: {
    ...mapActions({ updateImage: 'images/updateImage' }),
    ...mapMutations({
      toggleImageEditor: 'images/toggleImageEditor',
      setImage: 'images/setImage'
    }),
    async crop () {
      this.resultLoading = true
      const { payload } = this
      const cropper = this.$refs.cropper.getData()
      const x = Math.round(cropper.x)
      const y = Math.round(cropper.y)
      const width = Math.round(cropper.width)
      const height = Math.round(cropper.height)
      this.payload.content = await new Promise((resolve, reject) => {
        jimp
          .read(payload.url)
          .then(image => image
            .crop(x, y, width, height)
            .getBase64(payload.type, (err, res) => {
              if (err) { reject(err) }
              return resolve(res)
            }))
          .catch(err => reject(err))
      })
      this.resultLoading = false
    },
    setEditData () {
      this.payload.id = this.image.id
      this.payload.url = this.image.url
      this.payload.name = this.image.name.slice(0, this.image.name.lastIndexOf('.'))
      this.payload.ext = this.image.name.slice(this.image.name.lastIndexOf('.'))
      this.payload.size = this.image.size
      this.payload.type = this.image.type
    },
    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }
      this.submitLoading = true
      const { id, name, ext, type, size, content } = this.payload
      await this.updateImage({
        id,
        path: `templates`,
        name: `${name}${ext}`,
        size,
        type,
        content
      })
      this.submitLoading = false
      this.close()
    },
    cleanData () {
      this.submitLoading = false
      this.resultLoading = false
      this.imageExt = null
      this.payload = {
        id: null,
        url: null,
        name: null,
        ext: null,
        size: null,
        type: null,
        content: null
      }
      this.setImage(null)
      this.$validator.reset()
    },
    close () {
      this.toggleImageEditor(false)
      this.cleanData()
    }
  }
}
</script>
<style>
  .cropper-bg {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGElEQVQYlWNgYGCQwoKxgqGgcJA5h3yFAAs8BRWVSwooAAAAAElFTkSuQmCC) repeat;
    background-color: rgba(0, 0, 0, 0);
    overflow: hidden;
  }
</style>
